/* eslint-disable react-native/no-inline-styles */
import React, {CSSProperties, FC, useMemo, useState} from 'react';
import {TraceLogo} from 'design-system/src/assets/ImageSvg';
import {_DefaultHeaderRoot} from './DefaultHeader.styled';
import useDefaultTheme from 'design-system/src/Theme/useTheme';
import appAuthSlice from '@src/Store/Slices/AppSlice/auth.slice';
import {useAppDispatch, useAppSelector} from '@src/Store/hooks';
import SuspenseAfterRequired from 'design-system/src/library/AfterRequired/SuspenseAfterRequired';
import useBreakpoint from 'design-system/src/WebComponent/Grid/hooks/useBreakpoint';
import useIsLoggedIn from '@src/Providers/AuthProvider/useIsLoggedIn';
import useNavigation from '@src/Navigation/useNavigation';
import LoginMenu from '@src/layout/shared/components/LoginMenu/LoginMenu';
import LangSwitcher from '@src/layout/shared/components/LangSwitch/LangSwitcher';
import styled from 'styled-components';
import {appNavigate} from '@src/utils/navigationUtils';
import {Routes} from '@src/Constant/routes';

const ModalAuthentication = React.lazy(
  () => import('@src/App/components/ModalAuthentication/ModalAuthentication'),
);

interface DefaultHeaderProps {
  hideLogo?: boolean;
  isLangueSwitcher?: boolean;
  style?: CSSProperties;
}

const ActionsMenuContainer = styled.div`
  display: flex;
  flex-direction: horizontal;
  align-items: center;
`;

const DefaultHeader: FC<DefaultHeaderProps> = ({hideLogo, style}) => {
  const dispatch = useAppDispatch();
  const openAuthenticationModal = useAppSelector(
    state => state.appAuth.openAuthenticationModal,
  );
  const {isLoggedIn, isLoading} = useIsLoggedIn();
  const rootNavigation = useNavigation();
  const {isMobile} = useBreakpoint();
  const defaultTheme = useDefaultTheme();

  const onBackToHome = () => rootNavigation.navigate('/');

  return (
    <>
      <_DefaultHeaderRoot style={style}>
        {!hideLogo && (
          <div
            className="logo"
            style={{cursor: 'pointer'}}
            onClick={onBackToHome}>
            <TraceLogo width={136.6} height={24} />
          </div>
        )}

        <ActionsMenuContainer className="actions-menu">
          <LoginMenu
            isLoading={isLoading}
            isMobile={isMobile}
            isLoggedIn={isLoggedIn}
            showSignUp={false}
          />

          <LangSwitcher theme={defaultTheme} />
        </ActionsMenuContainer>

        <SuspenseAfterRequired required={openAuthenticationModal?.open}>
          <ModalAuthentication
            isOpen={!!openAuthenticationModal?.open}
            onClose={() => {
              dispatch(appAuthSlice.actions.closeAuthModal());
            }}
          />
        </SuspenseAfterRequired>
      </_DefaultHeaderRoot>

      <style
        dangerouslySetInnerHTML={{
          __html: `body {overflow: ${openAuthenticationModal?.open ? 'hidden' : 'auto!important'};}`,
        }}
      />
    </>
  );
};

export default DefaultHeader;
